import React from "react";
import { observer } from "mobx-react";
import {
  Box,
  Card,
  Text,
  Badge,
  Group,
  Progress,
  SimpleGrid,
  Table,
  Button,
  ActionIcon,
} from "@mantine/core";
import TransactionsPopover from "./transactionsPopover";
import { Cubby } from "../stores/Cubby";
import CloseChannelButton from "./modals/closeChannel";
import ChannelProgress from "./dataDisplay/channelProgress";
import { MODALS } from "../helpers/constants";
import {
  IconAbacus,
  IconCircleLetterX,
  IconCircleMinus,
  IconInfoCircle,
  IconTrash,
} from "@tabler/icons-react";
import {
  makeChannelDisplayName,
  shouldShowInboundReserveWarning,
  shouldShowOutboundReserveWarning,
} from "../helpers/channels";
import _ from "lodash";

const ChannelsList = observer(({ cubby }: { cubby: Cubby }) => {
  const activeChannels = _.chain(cubby.channelsList.data)
    .filter((channel) => channel.synthetic_status !== "closed")
    .sortBy((channel) => {
      const openingData = channel.channel_opening_transaction_data;
      if (!openingData || !openingData.blocktime) {
        // Channels without blocktime come first, sorted by time_online ascending
        return [0, channel.time_online];
      } else {
        // Channels with blocktime come next, sorted by blocktime descending
        return [1, -openingData.blocktime];
      }
    })
    .value();

  console.log("activeChannels", activeChannels);

  return (
    <Box>
      {activeChannels.length > 0 && (
        <SimpleGrid
          cols={{ base: 1 }}
          spacing={{ base: "md", sm: "lg", lg: "xl" }}
          verticalSpacing={{ base: "md", sm: "lg", lg: "xl" }}
        >
          {activeChannels.map((channel, index) => {
            const confirmationCount =
              channel.confirmation_count > 11
                ? "many"
                : channel.confirmation_count;
            // console.log("channel in list", channel);
            return (
              <Card key={index} shadow="sm" padding="xs" radius="md" withBorder>
                <Group justify="space-between">
                  <Text>{makeChannelDisplayName(channel)}</Text>
                  <Group>
                    <ActionIcon.Group>
                      <ActionIcon
                        onClick={() => {
                          cubby.setCurrentlyFocusedChannelTransactionIdForChannelInfo(
                            channel
                          );
                          // cubby.setModal(MODALS.SHOW_CHANNEL);
                        }}
                        variant="subtle"
                        color="gray"
                        aria-label="channel info"
                      >
                        <IconAbacus stroke={1.5} />
                      </ActionIcon>

                      {channel.synthetic_status !== "closed" &&
                        !channel.is_closing &&
                        !channel.is_opening &&
                        cubby.isConsideredReadyForBasicLightningApiRequests ==
                          true && (
                          <ActionIcon
                            variant="subtle"
                            color="gray"
                            aria-label="close channel"
                            onClick={() => {
                              if (channel.is_partner_initiated === false) {
                                cubby.getFeeEstimateForArbitrarySatoshisAmount(
                                  10000
                                );
                              }
                              cubby.setCurrentlyFocusedChannelTransactionIdForChannelClosure(
                                channel
                              );
                            }}
                          >
                            <IconCircleMinus stroke={1.5} />
                          </ActionIcon>
                        )}
                      {/* {index == 0 && (
                        <ActionIcon
                          variant="subtle"
                          color="gray"
                          component="a"
                          target="_blank"
                          href={"https://docs.megalithic.me"}
                          aria-label="Info"
                        >
                          <IconInfoCircle stroke={1.5} />
                        </ActionIcon>
                      )} */}
                    </ActionIcon.Group>
                  </Group>
                </Group>

                <ChannelProgress channel={channel} />
                <Group gap="xs">
                  {channel.is_private && (
                    <Badge color="var(--mantine-color-gray-8)">Private</Badge>
                  )}

                  {channel.is_private == false && (
                    <Badge color="var(--mantine-color-gray-8)">public</Badge>
                  )}
                  {channel.is_active &&
                    channel.is_private == false &&
                    channel.confirmation_count &&
                    channel.confirmation_count < 6 && (
                      <Badge color="var(--mantine-color-gray-8)">
                        Waiting For Confirmations
                      </Badge>
                    )}
                  {channel.is_active && (
                    <Badge color="var(--mantine-color-gray-8)">Active</Badge>
                  )}
                  {shouldShowOutboundReserveWarning(channel) && (
                    <Badge color="var(--mantine-color-gray-8)">
                      outbound under reserve
                    </Badge>
                  )}
                  {shouldShowInboundReserveWarning(channel) && (
                    <Badge color="var(--mantine-color-gray-8)">
                      inbound under reserve
                    </Badge>
                  )}

                  {channel.is_closing && !channel.is_timelocked && (
                    <Badge color="red">Closing</Badge>
                  )}
                  {!channel.is_active &&
                    !channel.is_opening &&
                    !channel.is_closing && <Badge color="red">Offline</Badge>}
                  {channel.is_opening && <Badge color="blue">Opening</Badge>}
                  {channel.is_timelocked && (
                    <>
                      <Badge color="orange">force close in progress</Badge>
                      {channel.timelock_blocks &&
                        channel.timelock_blocks > 10 && (
                          <Text size="sm" c="dimmed">
                            about{" "}
                            {Math.round((channel.timelock_blocks * 10) / 60)}{" "}
                            hours until funds are returned
                          </Text>
                        )}
                    </>
                  )}
                </Group>
              </Card>
            );
          })}
        </SimpleGrid>
      )}
      {/* <Text size="sm" ta="center" c="dimmed" fw={700}>
        CHANNELS{" "}
      </Text> */}
    </Box>
  );
});

export default ChannelsList;
